import React from "react";
import { Badge } from "./ui/badge";
import { Card, CardContent } from "./ui/card";
import { Star, Quote } from "lucide-react";
import { reviews, businessInfo } from "../data/mock";
import { Button } from "./ui/button";

const Reviews = () => {
  return (
    <section id="reviews" className="py-20 md:py-24 bg-slate-950 text-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <Badge className="bg-green-600 hover:bg-green-600 text-white border-0 mb-4">5-Star Rated</Badge>
            <h2 className="text-3xl md:text-5xl font-black tracking-tight leading-tight">What Marin drivers say about us</h2>
            <p className="text-slate-300 mt-4 text-lg">Real reviews from real neighbors in Novato, San Rafael, Petaluma, Mill Valley and beyond.</p>
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-xl px-4 py-3">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
              ))}
              <span className="font-black text-xl ml-2">5.0</span>
              <span className="text-slate-400 text-xs uppercase tracking-widest font-bold ml-1">Google</span>
            </div>
            <div className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-xl px-4 py-3">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
              ))}
              <span className="font-black text-xl ml-2">5.0</span>
              <span className="text-slate-400 text-xs uppercase tracking-widest font-bold ml-1">Yelp</span>
            </div>
          </div>
        </div>

        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {reviews.map((r) => (
            <Card key={r.name} className="bg-white/5 border-white/10 text-white card-hover">
              <CardContent className="p-6">
                <Quote className="w-8 h-8 text-green-500 mb-3" />
                <div className="flex gap-0.5 mb-3">
                  {[...Array(r.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <p className="text-slate-200 leading-relaxed text-sm mb-5">“{r.text}”</p>
                <div className="flex items-center justify-between pt-4 border-t border-white/10">
                  <div>
                    <div className="font-bold text-white">{r.name}</div>
                    <div className="text-xs text-slate-400">{r.location}</div>
                  </div>
                  <div className="text-xs text-slate-500">{r.date}</div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap gap-3 justify-center">
          <Button asChild className="bg-green-600 hover:bg-green-700 text-white font-bold">
            <a href={businessInfo.reviewUrl} target="_blank" rel="noreferrer">Leave a Google Review</a>
          </Button>
          <Button asChild variant="outline" className="bg-transparent border-white/30 text-white hover:bg-white hover:text-slate-900 font-bold">
            <a href={businessInfo.yelpUrl} target="_blank" rel="noreferrer">Review on Yelp</a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
